import React from "react";
import { FaUserAlt } from "react-icons/fa";

// tone → professional gradients
const toneMap = {
  violet: "from-violet-600 to-indigo-500",
  emerald: "from-emerald-600 to-teal-500",
  slate: "from-slate-600 to-gray-500",
  amber: "from-amber-600 to-orange-500",
};

const ringMap = {
  violet: "ring-violet-200",
  emerald: "ring-emerald-200",
  slate: "ring-slate-200",
  amber: "ring-amber-200",
};

const sizeMap = {
  sm: {  wrap: "h-7 w-7", icon: "text-[12px]" },
  md: { wrap: "h-7 w-7", icon: "text-[12px]" },
  lg: {  wrap: "h-7 w-7", icon: "text-[12px]" },
};

export default function CustomerAvatar({
  size = "md",
  tone = "violet",
  className = "",
  title = "Customer",
}) {
  return (
    <span
      title={title}
      className={[
        "inline-flex items-center justify-center rounded-2xl",
        "bg-gradient-to-br text-white shadow-lg",
        "ring-1 ring-offset-1",
        toneMap[tone],
        ringMap[tone],
        sizeMap[size].wrap,
        className,
      ].join(" ")}
      aria-label={title}
    >
      <FaUserAlt className={sizeMap[size].icon + " drop-shadow-sm opacity-95"} />
    </span>
  );
}
